import React, { useEffect, useRef, useState } from 'react';

import style from "./CreateCall.module.css";
import axios from 'axios';
import { baseUrl } from '../../data/baseURL';
import { format } from 'date-fns-jalali';
import { useLocation } from 'react-router-dom';

export default function EditCall(props){
    let state = useLocation();

    let [callerPhoneNumber, setCallerPhoneNumber] = useState("");
    let [callerBackoutPhonenumber, setCallerBackupPhoneNumber] = useState("");
    let [need, setNeed] = useState("");
    let [description, setDescription] = useState("");
    let [address, setAddress] = useState("");
    let [vehicleLicPlate, setVehicleLicPlate] = useState("");
    let [vehicleColor, setVehicleColor] = useState("");
    let [callerName, setCallerName] = useState("");
    let [callerAge, setCallerAge] = useState(0);
    let [callerCompanions, setCallerCompanions] = useState(0);
    let [callReason, setCallReason] = useState("");
    
    let [isPriorityOpen, setIsPriorityOpen] = useState(false);
    let priorityRef = useRef();
    let [selectedPriority, setSelectedPriority] = useState(-1);

    let [categories, setCategories] = useState([]);
    let [selectedCategory, setSelectedCategory] = useState(0);
    let [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
    let categoriesRef = useRef();

    let [states, setStates] = useState([]);
    let [selectedState, setSelectedState] = useState(0);
    let [selectedCity, setSelectedCity] = useState(0);
    let [isStatesOpen, setIsStatesOpen] = useState(false);
    let [isCitiesOpen, setIsCitiesOpen] = useState(false);
    let statesRef = useRef();
    let citiesRef = useRef();

    let [isVehicleTypeOpen, setIsVehicleTypeOpen] = useState(false);
    let [selectedVehicleType, setSelectedVehicleType] = useState(-1);
    let vehicleTypeRef = useRef();

    let [selectedGender, setSelectedGender] = useState(0); //0 is male 1 is female
    let [isGenderOpen, setIsGenderOpen] = useState(false);
    let genderRef = useRef();
    let [selectedRace, setSelectedRace] = useState(0);
    let [isRaceOpen, setIsRaceOpen] = useState(false);
    let raceRef = useRef();

    let [selectedMokeb, setSelectedMokeb] = useState(0);

    useEffect(() => {
        console.log(state);

        axios.get(baseUrl + "/Calls/Call", {
            params: {
                id: state.state.id
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            let data = res.data?.data;
            setCallerPhoneNumber(data?.callerPhoneNumber);
            setCallerBackupPhoneNumber(data?.backupPhoneNumber);
            setDescription(data?.callDescription);
            setCallerName(data?.callerName);
            setCallerAge(data?.callerAge);
            setSelectedGender(data?.callerSex);
            setSelectedPriority(data?.priority);
            setCallerCompanions(data?.callerCompanians);
            setSelectedRace(data?.callerRace);
            setSelectedState(data?.stateId);
            setSelectedCity(data?.cityId);
            setSelectedMokeb(data?.selectedMokebId == 0? null : data?.selectedMokebId);
            setNeed(data?.need);
            setSelectedVehicleType(data?.vehicle);
            setVehicleColor(data?.vehicleColor);
            setVehicleLicPlate(data?.vehicleLicensePlate);
            setAddress(data?.address);
            setCallReason(data?.callReason);
        })
    }, [state])

    useEffect(() => {
        axios.get(baseUrl + "/Calls/Category", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setCategories(res.data?.data);
        });

        axios.get(baseUrl + "/States").then((res) => {
            setStates(res.data?.data);
        });
    }, []);

    let [getHistoryTimeout, setHistoryTimeout] = useState();
    let [history, setHistory] = useState([]);

    useEffect(() => {
        if (callerPhoneNumber == "") {
            return;
        }
        if (getHistoryTimeout != undefined && getHistoryTimeout != null){
            clearTimeout(getHistoryTimeout);
        }
        setHistoryTimeout(setTimeout(() => {
            axios.get(baseUrl + "/Calls/Calls", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                params: {
                    phoneNumber: callerPhoneNumber
                }
            }).then((res) => {
                setHistory(res.data?.data);
            });
        }, 2000));
    }, [callerPhoneNumber]);

    let [selectedMokebType, setSelectedMokebType] = useState(-1);

    function getRaceText(){
        switch(selectedRace){
            case 0:
                return "سالار"
            case 1:
                return "زائر"
            case 2:
                return "راننده"
            case 3:
                return "خادم"
            case 4:
                return "ایرانی"
        }
    }

    function handleClick(ev){
        if (!priorityRef.current.contains(ev.target)){
            setIsPriorityOpen(false);
        }
        /*if (!categoriesRef.current.contains(ev.target)){
            setIsCategoriesOpen(false);
        }*/
        if (!statesRef.current.contains(ev.target)){
            setIsStatesOpen(false);
        }
        if (!citiesRef.current.contains(ev.target)){
            setIsCitiesOpen(false);
        }
        if (!vehicleTypeRef.current.contains(ev.target)){
            setIsVehicleTypeOpen(false);
        }
        if (!raceRef.current.contains(ev.target)){
            setIsRaceOpen(false);
        }
        if (!genderRef.current.contains(ev.target)){
            setIsGenderOpen(false);
        }
    }

    function getPriorityText(){
        switch(selectedPriority){
            case 0:
                return "سطح فوریت: آنی";
            case 1:
                return "سطح فوریت: فوری";
            case 2:
                return "سطح فوریت: مهم";
            case 3:
                return "سطح فوریت: عادی";
            default:
                return "سطح فوریت";
        }
    }

    function getVehicleTypeText(){
        switch(selectedVehicleType){
            case 0:
                return "وسیله نقلیه: پیاده"
            case 1:
                return "وسیله نقلیه: سواری"
            case 2:
                return "وسیله نقلیه: اتوبوس پاکستانی"
            case 3:
                return "وسیله نقلیه: اتوبوس ایرانی"
            default:
                return "وسیله نقیله"
        }
    }

    function selectPriority(priority){
        setSelectedPriority(priority);
        setIsPriorityOpen(false);
    }

    function selectCategory(id){
        setSelectedCategory(id);
        setIsCategoriesOpen(false);
    }

    function selectState(id){
        setSelectedState(id);
        setIsStatesOpen(false);
    }

    function selectCity(id){
        setSelectedCity(id);
        setIsCitiesOpen(false);
    }

    function selectVehicle(type){
        setSelectedVehicleType(type);
        setIsVehicleTypeOpen(false);
    }

    let [mokebs, setMokebs] = useState([]);
    useEffect(() => {
        axios.get(baseUrl + "/Calls/Mokebs", {
            params: {
                type: selectedMokebType || null,
                stateId: selectedState || null,
                cityId: selectedCity || null
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setMokebs(res.data.data);
        });
    }, [selectedMokebType, selectedCity, selectedState])

    useEffect(() => {
        window.addEventListener("mousedown", handleClick);

        return () => {
            window.removeEventListener("mousedown", handleClick);
        }
    }, []);

    function getStatusText(status){
        switch(states){
            case 0:
                return "در حال انجام";
            case 1:
                return "انجام شد";
            case 2:
                return "ارجاع شد";
        }
    }

    function submitHandle(){
        if (callerPhoneNumber == "" || callReason == "" || selectedState == 0 || selectedCity == 0){
            alert("پر کردن شماره تماس گیرنده و مسئله اصلی تماس و استان و شهر اجباریست");
            return;
        }
        axios.put(baseUrl + "/Calls", {
            id: state.state.id,
            callerPhoneNumber: callerPhoneNumber,
            backupPhoneNumber: callerBackoutPhonenumber,
            callDescription: description,
            callerName: callerName,
            callerAge: callerAge,
            callerSex: selectedGender,
            priority: selectedPriority,
            callerCompanians: callerCompanions,
            callerRace: selectedRace,
            stateId: selectedState,
            cityId: selectedCity,
            selectedMokebId: selectedMokeb,
            need: need,
            vehicle: selectedVehicleType,
            vehicleColor: vehicleColor,
            vehicleLicensePlate: vehicleLicPlate,
            address: address,
            callReason: callReason,
            status: 0
          }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
          }).then((res) => {
            alert(res.data.message);
            window.location.href = "/call-reports"
          });
    }

    return <>
        <div className={`${style.container}`}>
            <div className={`${style.header}`}>
                <div className={`${style.header_title}`}>
                    ثبت گزارش
                </div>
            </div>
            <div className={`${style.content}`}>
                <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='تلفن اصلی' value={callerPhoneNumber} onChange={(ev) => setCallerPhoneNumber(ev.target.value)}></input>
                </div>
                <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='تلفن پیگیری' value={callerBackoutPhonenumber} onChange={(ev) => {setCallerBackupPhoneNumber(ev.target.value)}}></input>
                </div>
                <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='مسئله تماس' value={callReason} onChange={(ev) => {setCallReason(ev.target.value)}}></input>
                </div>
                <div className={`${style.dropdown}`} ref={priorityRef}>
                    <div className={`${style.dropdown_placeholder}`} onClick={() => setIsPriorityOpen(true)}>
                        {getPriorityText()}
                    </div>
                    <div className={`${style.dropdown_icon}`} onClick={() => setIsPriorityOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </div>
                    <div className={`${isPriorityOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                        <div className={`${style.dropdown_content_item} ${selectedPriority == 0? style.dropdown_content_item_active : ""}`} onClick={() => selectPriority(0)}>1. آنی</div>
                        <div className={`${style.dropdown_content_item} ${selectedPriority == 1? style.dropdown_content_item_active : ""}`} onClick={() => selectPriority(1)}>2. فوری</div>
                        <div className={`${style.dropdown_content_item} ${selectedPriority == 2? style.dropdown_content_item_active : ""}`} onClick={() => selectPriority(2)}>3. مهم</div>
                        <div className={`${style.dropdown_content_item} ${selectedPriority == 3? style.dropdown_content_item_active : ""}`} onClick={() => selectPriority(3)}>4. عادی</div>
                    </div>
                </div>
                {/*<div className={`${style.dropdown}`} ref={categoriesRef}>
                    <div className={`${style.dropdown_placeholder}`} onClick={() => setIsCategoriesOpen(true)}>
                        {selectedCategory == 0? "انتخاب دسته بندی" : "دسته بندی انتخاب شده: " + categories.find(c => c.id == selectedCategory)?.name}
                    </div>
                    <div className={`${style.dropdown_icon}`} onClick={() => setIsCategoriesOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </div>
                    <div className={`${isCategoriesOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                        {
                            categories.map((category, index) => {
                                return <div className={`${style.dropdown_content_item} ${selectedCategory == category.id? style.dropdown_content_item_active : ""}`} onClick={() => selectCategory(category.id)}>{index + 1}. {category.name}</div>
                            })
                        }
                    </div>
                </div>*/}
                <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='نیاز' value={need} onChange={(ev) => setNeed(ev.target.value)}></input>
                </div>
                <div className={`${style.textarea}`}>
                    <textarea className={`${style.textarea_textarea}`} placeholder='توضیحات' value={description} onChange={(ev) => setDescription(ev.target.value)}></textarea>
                </div>
                <div className={`${style.dropdown}`} ref={statesRef}>
                    <div className={`${style.dropdown_placeholder}`} onClick={() => setIsStatesOpen(true)}>
                        {selectedState == 0? "استان" : "استان: " + states.find(s => s.id == selectedState)?.name}
                    </div>
                    <div className={`${style.dropdown_icon}`} onClick={() => setIsStatesOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </div>
                    <div className={`${isStatesOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                        {
                            states.map((state, index) => {
                                return <div className={`${style.dropdown_content_item} ${selectedState == state.id? style.dropdown_content_item_active : ""}`} onClick={() => selectState(state.id)}>{index + 1}. {state.name}</div>
                            })
                        }
                    </div>
                </div>
                <div className={`${style.dropdown}`} ref={citiesRef}>
                    <div className={`${style.dropdown_placeholder}`} onClick={() => setIsCitiesOpen(true)}>
                        {selectedCity == 0 || selectedState == 0? "شهرستان" : "شهرستان: " + states.find(s => s.id == selectedState)?.cities.find(c => c.id == selectedCity)?.name}
                    </div>
                    <div className={`${style.dropdown_icon}`} onClick={() => setIsCitiesOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </div>
                    <div className={`${isCitiesOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                        {
                            selectedState != 0 && states.find(s => s.id == selectedState)?.cities.map((city, index) => {
                                return <div className={`${style.dropdown_content_item} ${selectedCity == city.id? style.dropdown_content_item_active : ""}`} onClick={() => selectCity(city.id)}>{index + 1}. {city.name}</div>
                            })
                        }
                    </div>
                </div>
                <div className={`${style.textarea}`}>
                    <textarea className={`${style.textarea_textarea}`} placeholder='آدرس محل واقعه' value={address} onChange={(ev) => setAddress(ev.target.value)}></textarea>
                </div>
                <div className={`${style.dropdown}`} ref={vehicleTypeRef}>
                    <div className={`${style.dropdown_placeholder}`} onClick={() => setIsVehicleTypeOpen(true)}>
                        {getVehicleTypeText()}
                    </div>
                    <div className={`${style.dropdown_icon}`} onClick={() => setIsVehicleTypeOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </div>
                    <div className={`${isVehicleTypeOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                        <div className={`${style.dropdown_content_item} ${selectedVehicleType == 0? style.dropdown_content_item_active : ""}`} onClick={() => selectVehicle(0)}>1. پیاده</div>
                        <div className={`${style.dropdown_content_item} ${selectedVehicleType == 1? style.dropdown_content_item_active : ""}`} onClick={() => selectVehicle(1)}>2. سواری</div>
                        <div className={`${style.dropdown_content_item} ${selectedVehicleType == 2? style.dropdown_content_item_active : ""}`} onClick={() => selectVehicle(2)}>3. اتوبوس پاکستانی</div>
                        <div className={`${style.dropdown_content_item} ${selectedVehicleType == 3? style.dropdown_content_item_active : ""}`} onClick={() => selectVehicle(3)}>4. اتوبوس ایرانی</div>
                    </div>
                </div>
                {selectedVehicleType != 0?<> <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='پلاک وسیله نقلیه' value={vehicleLicPlate} onChange={(ev) => setVehicleLicPlate(ev.target.value)}></input>
                </div>
                <div className={`${style.input}`}>
                    <input className={`${style.input_input}`} placeholder='رنگ وسیله نقلیه' value={vehicleColor} onChange={(ev) => setVehicleColor(ev.target.value)}></input>
                </div></> : <></>}
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{width: "20%"}}>
                            نام تماس گیرنده
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "20%"}}>
                            سن
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "20%"}}>
                            جنسیت
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "20%"}}>
                            نفرات همراه
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "20%"}}>
                            قشر
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        <div className={`${style.table_body_i}`}><div className={`${style.table_body_item}`} style={{width: "20%"}}>
                            <input className={`${style.table_body_item_input}`} placeholder='نام تماس گیرنده' value={callerName} onChange={(ev) => setCallerName(ev.target.value)}></input>
                        </div>
                        <div className={`${style.table_body_item}`} style={{width: "20%"}}>
                            <input defaultValue={0} className={`${style.table_body_item_input}`} value={callerAge} onChange={(ev) => setCallerAge(ev.target.value)}></input>
                        </div>
                        <div className={`${style.table_body_item}`} style={{width: "20%"}} onClick={() => setSelectedGender(selectedGender == 0? 1 : 0)}>
                            <div className={`${style.dropdown}`} ref={genderRef}>
                                <div className={`${style.dropdown_placeholder}`} onClick={() => setIsGenderOpen(true)}>
                                    {selectedGender == 0? "مرد" : "زن"}
                                </div>
                                <div className={`${style.dropdown_icon}`} onClick={() => setIsGenderOpen(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </div>
                                <div className={`${isGenderOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                                    <div className={`${style.dropdown_content_item} ${selectedGender == 0? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedGender(0)}>1. مرد</div>
                                    <div className={`${style.dropdown_content_item} ${selectedGender == 1? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedGender(1)}>2. زن</div>
                                </div>
                            </div>
                        </div>
                        <div className={`${style.table_body_item}`} style={{width: "20%"}}>
                            <input defaultValue={0} className={`${style.table_body_item_input}`} value={callerCompanions} onChange={(ev) => setCallerCompanions(ev.target.value)}></input>
                        </div>
                        <div className={`${style.table_body_item}`} style={{width: "20%"}}>
                            <div className={`${style.dropdown}`} ref={raceRef}>
                                <div className={`${style.dropdown_placeholder}`} onClick={() => setIsRaceOpen(true)}>
                                    {getRaceText()}
                                </div>
                                <div className={`${style.dropdown_icon}`} onClick={() => setIsRaceOpen(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className={`${style.dropdown_icon_svg}`}><path d="M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </div>
                                <div className={`${isRaceOpen? style.dropdown_content : style.dropdown_content_hide}`}>
                                    <div className={`${style.dropdown_content_item} ${selectedVehicleType == 0? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedRace(0)}>1. سالار</div>
                                    <div className={`${style.dropdown_content_item} ${selectedVehicleType == 1? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedRace(1)}>2. زائر</div>
                                    <div className={`${style.dropdown_content_item} ${selectedVehicleType == 2? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedRace(2)}>3. رانندی</div>
                                    <div className={`${style.dropdown_content_item} ${selectedVehicleType == 3? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedRace(3)}>4. خادم</div>
                                    <div className={`${style.dropdown_content_item} ${selectedVehicleType == 4? style.dropdown_content_item_active : ""}`} onClick={() => setSelectedRace(4)}>5. ایرانی</div>
                                </div>
                            </div>
                        </div></div>
                    </div>
                </div>
                <div className={`${style.label}`}>
                    گزارشات این تلفن
                </div>
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            ردیف
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            تاریخ
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نوع
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نام
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نتیجه
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            آدرس
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        {
                            history.map((h, index) => {
                                return <div className={`${style.table_body_i}`}>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {index + 1}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {format(new Date(h.createdAt * 1000), "d MMMM yyyy")}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}} onClick={() => setSelectedGender(selectedGender == 0? 1 : 0)}>
                                        {h.categoryName}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}}>
                                        {h.callerName}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}} onClick={() => {selectedRace < 4? setSelectedRace(selectedRace + 1) : setSelectedRace(0)}}>
                                        {getStatusText(h.status)}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{width: "16%"}} onClick={() => {selectedRace < 4? setSelectedRace(selectedRace + 1) : setSelectedRace(0)}}>
                                        {h.address}
                                    </div>
                                </div>
                            })
                        }
                        {
                            history.length == 0? <div className={`${style.table_body_item}`} style={{width: "100%"}}>
                                                    بدون داده
                                                </div> : <></>
                        }
                    </div>
                </div>
                <div className={`${style.label}`}>
                    موکب های دارای ظرفیت
                </div>
                <div className={`${style.mokeb_type_selector}`}>
                    <div className={`${style.mokeb_type_item} ${selectedMokebType == 0? style.mokeb_type_item_active : ""}`} onClick={() => setSelectedMokebType(0)}>
                        اسکان
                    </div>
                    <div className={`${style.mokeb_type_item} ${selectedMokebType == 1? style.mokeb_type_item_active : ""}`} onClick={() => setSelectedMokebType(1)}>
                        پذیرایی
                    </div>
                    <div className={`${style.mokeb_type_item} ${selectedMokebType == 2? style.mokeb_type_item_active : ""}`} onClick={() => setSelectedMokebType(2)}>
                        پمپ بنزین
                    </div>
                    <div className={`${style.mokeb_type_item} ${selectedMokebType == 3? style.mokeb_type_item_active : ""}`} onClick={() => setSelectedMokebType(3)}>
                        مسجد
                    </div>
                </div>
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نوع
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            استان
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            شهرستان
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            نام
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            شماره تلفن
                        </div>
                        <div className={`${style.table_header_item}`} style={{width: "16%"}}>
                            آدرس
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        {
                            mokebs.map((h, index) => {
                                return <div className={`${style.table_body_i}`}>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.type}
                                    </div>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.state}
                                    </div>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.city}
                                    </div>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.name}
                                    </div>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.phoneNumber}
                                    </div>
                                    <div className={`${style.table_body_item} ${selectedMokeb == h.id? style.table_body_item_active : ""}`} style={{width: "16%"}} onClick={() => setSelectedMokeb(h.id)}>
                                        {h.address}
                                    </div>
                                </div>
                            })
                        }
                        {
                            mokebs.length == 0? <div className={`${style.table_body_item}`} style={{width: "100%"}}>
                                                    بدون داده
                                                </div> : <></>
                        }
                    </div>
                </div>
                <iframe src='https://141.ir' style={{gridColumnStart: "1", gridColumnEnd: "4", marginLeft: "3%", marginRight: "3%", width: "94%", height: "600px"}}></iframe>
                <div className={`${style.submit}`}>
                    <div className={`${style.submit_cancel}`} onClick={() => window.location.href = "/call-reports"}>لغو</div>
                    <div className={`${style.submit_submit}`} onClick={submitHandle}>ثبت</div>
                
                </div>
            </div>
        </div>
    </>
}